import * as client_hooks from '../../../src/hooks.client.ts';


export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29')
];

export const server_loads = [];

export const dictionary = {
		"/(app)/(home)": [11,[2,3]],
		"/(app)/(home)/accounts": [12,[2,3]],
		"/(app)/(home)/accounts/[account_id]": [13,[2,4]],
		"/(app)/(home)/accounts/[account_id]/access": [14,[2,4]],
		"/(data-room)/authentication/[magic_link]": [27,[9],[10]],
		"/(data-room)/auth/[magic_link]": [26],
		"/(data-room)/data-room/error": [29],
		"/(data-room)/data-room/[data_room_id]": [28],
		"/(app)/datarooms": [16,[5]],
		"/(app)/g/[org_url_slug]": [17,[2,6]],
		"/(app)/g/[org_url_slug]/capital-calls": [18,[2,6]],
		"/(app)/g/[org_url_slug]/datarooms": [19,[2,6]],
		"/(app)/g/[org_url_slug]/datarooms/[data_room_id]": [20,[7]],
		"/(app)/g/[org_url_slug]/datarooms/[data_room_id]/document/[document_id]": [21,[7]],
		"/(app)/g/[org_url_slug]/datarooms/[data_room_id]/folder/[folder_id]": [22,[7]],
		"/(app)/g/[org_url_slug]/documents": [23,[2,6]],
		"/(app)/g/[org_url_slug]/documents/[document_id]": [24,[2]],
		"/(app)/g/[org_url_slug]/investments/[investment_id]": [25,[2,8]],
		"/(app)/(home)/settings": [15,[2,3]]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ error }) => { console.error(error) }),
	init: client_hooks.init,
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';